<template>
  <a
    class="m-0 block shrink-0 p-0"
    href="https://bcorp.com"
    rel="noopener noreferrer nofollow"
    target="_blank"
    title="B Corp Certification"
  >
    <RevIllustration
      alt="B Corp Certification"
      class="h-[76px] w-[46px]"
      :height="76"
      src="/img/b-corp/B-Corp-Logo-Black.svg"
      :width="46"
    />
  </a>
</template>

<script setup lang="ts">
import { RevIllustration } from '@ds/components/Illustration'
</script>
